export default __webpack_public_path__ + "static/media/aralogo.9d23e433.png";